export default "__VITE_ASSET__DheoSmYj__"